import { gql } from "graphql-request";
export const ARTICLES_DOMAIN_OFFER_QUERY = gql`
    query getArticlesDomainOffers(
        $categoryId: Int
        $language: String!
        $domainId: Int
    ) {
        allDomainOffers(domainId: $domainId, categoryId: $categoryId) {
            placements
            offers(orderByDesc: weight, isDeleted: false, isActive: true) {
                id
                slug
                title
                logo {
                    path
                    fullPath
                }
                features(languageEq: $language) {
                    id
                    type
                    description
                    translations {
                        key
                        value
                        language
                    }
                }
                url(isActive: true, isDeleted: false, languageEq: $language) {
                    isMain
                    main {
                        url
                    }
                    url
                }
                translations {
                    key
                    value
                    language
                }
            }
        }
    }
`;
